import React, { useCallback, useEffect, useState } from 'react';
import { DescriptionCompleter } from './description-completer/index.tsx';
import type { Props } from './types.tsx';

export const AiProactiveDescriptionCompleter = (props: Props) => {
	const { editorApi } = props;
	const [showFooter, setShowFooter] = useState(false);
	const [currentCard, setCurrentCard] = useState<{ title: string; url: string } | undefined>();

	useEffect(() => {
		// tracking the shared card state plugin
		// determines whether the AI suggest button should be shown or not
		const unsub = editorApi?.card?.sharedState.onChange(({ nextSharedState }) => {
			if (!nextSharedState) return;
			const { cards } = nextSharedState;
			const resolvedCard = cards.find((card) => card?.title);
			if (!resolvedCard) return;
			const { url: firstAccessibleConfluenceLink = '', title = '' } = resolvedCard;
			const hasAccess = typeof firstAccessibleConfluenceLink === 'string';

			// ToDo: add logic the check when show the footer
			// https://jplat.atlassian.net/browse/GRAVITYAI-2186
			setShowFooter(hasAccess);
			setCurrentCard({ url: firstAccessibleConfluenceLink, title });
		});
		return unsub;
	}, [editorApi]);

	const onClose = useCallback(() => {
		setShowFooter(false);
	}, []);

	const onClick = useCallback(() => {
		// ToDo: add event trigger to issue reformatter
		// https://jplat.atlassian.net/browse/GRAVITYAI-2196
		// https://jplat.atlassian.net/browse/GRAVITYAI-2199
		currentCard;
	}, [currentCard]);

	return showFooter && <DescriptionCompleter onClick={onClick} onClose={onClose} />;
};
